<div class="user-status-widget {{ item[field] ? 'active' : 'inactive' }}">
  <i class="user-status-icon fas" [ngClass]="{ 'fa-check': item[field], 'fa-spinner': !item[field] }"> </i>
  {{ 'market_discovery.user.status.' + (item[field] ? 'active' : 'inactive') | translate }}
</div>
